import { BaseMapData } from './BaseMapData.ts';
import { LobbyImage, MapSettingEnum, ModeSettingEnum, ScenarioSettingEnum } from '@colonist/types';
import { StoreMapType } from '../entity_datas/StoreEnums.ts';
export class MapDataEarth extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [
            StoreMapType.Earth
        ], this.mapEnum = MapSettingEnum.Earth, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.earth.title'
        }, this.image = LobbyImage.MapEarthPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P,
            ModeSettingEnum.ColonistRush4P
        ], this.includeInFreeMapRotationIfActive = true, this.isActive = true, this.numberOfLandTiles = 81, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataEarthSeafarers extends MapDataEarth {
    constructor(...args){
        super(...args), this.mapEnum = MapSettingEnum.EarthSeafarers, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers56P
        ], this.includeInFreeMapRotationIfActive = false, this.numberOfLandTiles = 81, this.scenario = ScenarioSettingEnum.SS1HeadingForNewShores;
    }
}
export class MapDataUSA extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [
            StoreMapType.USA
        ], this.mapEnum = MapSettingEnum.USA, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.usa.title'
        }, this.image = LobbyImage.MapUSAPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P,
            ModeSettingEnum.ColonistRush4P
        ], this.includeInFreeMapRotationIfActive = true, this.isActive = true, this.numberOfLandTiles = 144, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataUK extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [
            StoreMapType.UK
        ], this.mapEnum = MapSettingEnum.UK, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.uk.title'
        }, this.image = LobbyImage.MapUKPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P,
            ModeSettingEnum.ColonistRush4P
        ], this.includeInFreeMapRotationIfActive = true, this.isActive = true, this.numberOfLandTiles = 63, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataUKSeafarers extends MapDataUK {
    constructor(...args){
        super(...args), this.mapEnum = MapSettingEnum.UKSeafarers, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers56P
        ], this.includeInFreeMapRotationIfActive = false, this.numberOfLandTiles = 63, this.scenario = ScenarioSettingEnum.SS1HeadingForNewShores;
    }
}
export class MapDataDiamond extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [
            StoreMapType.Diamond
        ], this.mapEnum = MapSettingEnum.Diamond, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.diamond.title'
        }, this.image = LobbyImage.MapDiamondPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P,
            ModeSettingEnum.ColonistRush4P
        ], this.includeInFreeMapRotationIfActive = true, this.isActive = true, this.numberOfLandTiles = 24, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataGear extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [
            StoreMapType.Gear
        ], this.mapEnum = MapSettingEnum.Gear, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.gear.title'
        }, this.image = LobbyImage.MapGearPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P,
            ModeSettingEnum.ColonistRush4P
        ], this.includeInFreeMapRotationIfActive = true, this.isActive = true, this.numberOfLandTiles = 43, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataLakes extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [
            StoreMapType.Lakes
        ], this.mapEnum = MapSettingEnum.Lakes, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.lakes.title'
        }, this.image = LobbyImage.MapLakesPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P,
            ModeSettingEnum.ColonistRush4P
        ], this.includeInFreeMapRotationIfActive = true, this.isActive = true, this.numberOfLandTiles = 39, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataPond extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [
            StoreMapType.Pond
        ], this.mapEnum = MapSettingEnum.Pond, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.pond.title'
        }, this.image = LobbyImage.MapPondPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P,
            ModeSettingEnum.ColonistRush4P
        ], this.includeInFreeMapRotationIfActive = true, this.isActive = true, this.numberOfLandTiles = 24, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataTwirl extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [
            StoreMapType.Twirl
        ], this.mapEnum = MapSettingEnum.Twirl, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.twirl.title'
        }, this.image = LobbyImage.MapTwirlPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P,
            ModeSettingEnum.ColonistRush4P
        ], this.includeInFreeMapRotationIfActive = true, this.isActive = true, this.numberOfLandTiles = 42, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataShuffleBoard extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [
            StoreMapType.ShuffleBoard
        ], this.mapEnum = MapSettingEnum.ShuffleBoard, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.shuffleBoard.title'
        }, this.image = LobbyImage.MapShuffleBoardPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P,
            ModeSettingEnum.ColonistRush4P
        ], this.includeInFreeMapRotationIfActive = true, this.isActive = true, this.numberOfLandTiles = 25, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataBlackForest extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [
            StoreMapType.BlackForest
        ], this.mapEnum = MapSettingEnum.BlackForest, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.blackForest.title'
        }, this.image = LobbyImage.MapBlackForestPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P
        ], this.includeInFreeMapRotationIfActive = true, this.isActive = true, this.numberOfLandTiles = 55, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataVolcano extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [
            StoreMapType.Volcano
        ], this.mapEnum = MapSettingEnum.Volcano, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.volcano.title'
        }, this.image = LobbyImage.MapVolcanoPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P
        ], this.includeInFreeMapRotationIfActive = true, this.isActive = true, this.numberOfLandTiles = 71, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataGoldRush extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [
            StoreMapType.GoldRush
        ], this.mapEnum = MapSettingEnum.GoldRush, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.goldRush.title'
        }, this.image = LobbyImage.MapGoldRushPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P
        ], this.includeInFreeMapRotationIfActive = true, this.isActive = true, this.numberOfLandTiles = 31, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataVietnam extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.Vietnam, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.vietnam.title'
        }, this.image = LobbyImage.MapVietnamPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 98, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataJellyFish extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.JellyFish, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.jellyFish.title'
        }, this.image = LobbyImage.MapJellyFishPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 30, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataCircle extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.Circle, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.circle.title'
        }, this.image = LobbyImage.MapCirclePreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 30, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataKite extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.Kite, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.kite.title'
        }, this.image = LobbyImage.MapKitePreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 31, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataDuel extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.Duel, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.duel.title'
        }, this.image = LobbyImage.MapDuelPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 11, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataMiniBase extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.MiniBase, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.miniBase.title'
        }, this.image = LobbyImage.MapMiniBasePreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 14, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataKingOfTheHill extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.KingOfTheHill, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.kingOfTheHill.title'
        }, this.image = LobbyImage.MapKingOfTheHillPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P
        ], this.includeInFreeMapRotationIfActive = false, // this map is broken and should never be enabled
        this.isActive = false, this.numberOfLandTiles = 26, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataMountainOfRiches extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.MountainOfRiches, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.mountainOfRiches.title'
        }, this.image = LobbyImage.MapMountainOfRichesPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.CitiesAndKnights4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 24, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataTwoIsles extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.TwoIsles, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.twoIsles.title'
        }, this.image = LobbyImage.MapTwoIslesPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 25, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataDoggo extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.Doggo, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.doggo.title'
        }, this.image = LobbyImage.MapDoggoPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 46, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataTradeIslands extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.TradeIslands, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.tradeIslands.title'
        }, this.image = LobbyImage.MapTradeIslandsPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P
        ], this.includeInFreeMapRotationIfActive = false, // this map is broken and should never be enabled
        this.isActive = false, this.numberOfLandTiles = 27, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataTradeIslandSeafarers extends MapDataTradeIslands {
    constructor(...args){
        super(...args), this.mapEnum = MapSettingEnum.TradeIslandsSeafarers, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P
        ], this.includeInFreeMapRotationIfActive = false, this.numberOfLandTiles = 27, this.scenario = ScenarioSettingEnum.SS1HeadingForNewShores;
    }
}
export class MapDataTurningTidesClassic extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.TurningTidesClassic, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.turningTidesClassic.title'
        }, this.image = LobbyImage.MapTurningTidesPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 77, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataTurningTidesSeafarers extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.TurningTidesSeafarers, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.turningTidesSeafarers.title'
        }, this.image = LobbyImage.MapTurningTidesPreview, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 54, this.scenario = ScenarioSettingEnum.SS4ThroughTheDesert;
    }
}
export class MapDataRomania extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.Romania, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.romania.title'
        }, this.image = LobbyImage.MapRomaniaPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 56, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataMonopoly extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.Monopoly, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.monopoly.title'
        }, this.image = LobbyImage.MapMonopolyPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 19, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataIstanbul extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.Istanbul, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.istanbul.title'
        }, this.image = LobbyImage.MapIstanbulPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 45, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataIstanbulSeafareres extends MapDataIstanbul {
    constructor(...args){
        super(...args), this.mapEnum = MapSettingEnum.IstanbulSeafarers, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers56P
        ], this.includeInFreeMapRotationIfActive = false, this.numberOfLandTiles = 45, this.scenario = ScenarioSettingEnum.SS1HeadingForNewShores;
    }
}
export class MapDataEurope extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.Europe, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.europe.title'
        }, this.image = LobbyImage.MapEuropePreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P,
            ModeSettingEnum.Classic78P,
            ModeSettingEnum.CitiesAndKnights4P,
            ModeSettingEnum.CitiesAndKnights56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 96, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataEuropeSeafarers extends MapDataEurope {
    constructor(...args){
        super(...args), this.mapEnum = MapSettingEnum.EuropeSeafarers, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers56P
        ], this.includeInFreeMapRotationIfActive = false, this.numberOfLandTiles = 96, this.scenario = ScenarioSettingEnum.SS1HeadingForNewShores;
    }
}
export class MapDataStripes extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.Stripes, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.stripes.title'
        }, this.image = LobbyImage.MapStripesPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.CitiesAndKnights4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 20, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataMonopolyIslands extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.MonopolyIslands, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.monopolyIslands.title'
        }, this.image = LobbyImage.MapMonopolyIslandsPreview, this.compatibleGameModes = [
            ModeSettingEnum.Classic4P,
            ModeSettingEnum.Classic56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = false, this.numberOfLandTiles = 49, this.scenario = ScenarioSettingEnum.None;
    }
}
export class MapDataMonopolyIslandsSeafarers extends MapDataMonopolyIslands {
    constructor(...args){
        super(...args), this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P
        ], this.mapEnum = MapSettingEnum.MonopolyIslandsSeafarers, this.scenario = ScenarioSettingEnum.SS1HeadingForNewShores, this.isActive = false, this.numberOfLandTiles = 43;
    }
}
